import { render, staticRenderFns } from "./paidOrders.vue?vue&type=template&id=45982162&scoped=true&"
import script from "./paidOrders.vue?vue&type=script&lang=js&"
export * from "./paidOrders.vue?vue&type=script&lang=js&"
import style0 from "./paidOrders.vue?vue&type=style&index=0&id=45982162&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45982162",
  null
  
)

export default component.exports